import { clickInteractionType } from '../types';

import type {
  ComponentTrackingConfig,
  ComboRecommendationTrackingConfig,
  MBDEvent,
} from '../types';

export const buildImpressionEvent = (
  screenViewGuid: string,
  config: ComponentTrackingConfig,
): MBDEvent => ({
  view_guid: screenViewGuid,
  common: {
    component_name: config.componentName,
    numeric_properties: {},
    string_properties: {
      vertical: config.vertical,
      calendarTab: config.calendarTab,
    },
    boolean_properties: {},
  },
});

export const buildInteractionEvent = (
  impressionGuid: string,
  config: ComponentTrackingConfig,
): MBDEvent => ({
  element_impression_guid: impressionGuid,
  interaction_type: clickInteractionType,
  common: {
    component_name: config.componentName,
    numeric_properties: {},
    string_properties: {
      vertical: config.vertical,
      calendarTab: config.calendarTab,
    },
    boolean_properties: {},
  },
});

export const buildComboRecommendationImpressionEvent = (
  screenViewGuid: string,
  config: ComboRecommendationTrackingConfig,
): MBDEvent => ({
  view_guid: screenViewGuid,
  common: {
    component_name: config.componentName,
    numeric_properties: config.numericProperties ?? {},
    string_properties: config.stringProperties ?? {},
    boolean_properties: config.booleanProperties ?? {},
  },
});

export const buildComboRecommendationInteractionEvent = (
  impressionGuid: string,
  config: ComboRecommendationTrackingConfig,
): MBDEvent => ({
  element_impression_guid: impressionGuid,
  interaction_type: clickInteractionType,
  common: {
    component_name: config.componentName,
    numeric_properties: config.numericProperties ?? {},
    string_properties: config.stringProperties ?? {},
    boolean_properties: config.booleanProperties ?? {},
  },
});
